import ModalEditTable from '../CRUDUtils/ModalEditTable';
import { Link } from 'react-router-dom';

export default function StreamResolutionsPage() {
  const columns = [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      sorter: (a, b) => a.name.localeCompare(b.name)
    },
  ];

  const formFields = [
    {
      name: 'stream_resolution_id',
      label: 'ID',
      type: 'textarea',
      placeholder: 'ID',
      disabled: true
    },
    {
      name: 'name',
      label: 'Name',
      type: 'textarea',
      placeholder: 'Model',
      rules: [{ required: true, message: 'Must Enter a Stream Resolution Name!' }]
    },
  ];


  return (
    <div className='container-wrapper'>
      <ModalEditTable
        createEndpoint="create/streamresolutions"
        readEndpoint="read/streamresolutions"
        editEndpoint="update/streamresolutions"
        deleteEndpoint="delete/streamresolutions"
        columns={columns}
        formFields={formFields}
        title="Stream Resolutions"
      />
    </div>
  );
}